const config = {
    'dispatch': {
        'bigData-btn-search': '订单管理-大物流,调度管理,,调度管理-查询'
    },
    'tmsDispatchOrder': {
        'bigData-btn-search': '订单管理-大物流,发车单管理,,发车单管理-查询'
    },
    'equipment': {
        'bigData-btn-search': '订单管理-大物流,设备管理,,设备管理-查询'
    },
    'revocationCarrierHistory': {
        'bigData-btn-search': '订单管理-大物流,报表管理,撤回承运商历史,撤回承运商历史-查询'
    }
};
export default config;